import { provideReducer } from '@/library/react/providers/provideReducer';

import { Action, defaultState, reducer, State } from '../reducers';

export const { Provider: NotificationCountProvider, useState: useNotificationCount } = provideReducer<State, Action>({
  reducer,
  defaultState,
});
